import { useEffect, useState } from 'react'

import emptyStateEvent from '../../utils/analytics/emptyStateEvent'

/**
 * Push empty state analytics event to datalayer.
 *
 * @param itemList
 * @param isLoading
 * @param analyticsContext
 * @param queryDependencies - Dependencies that change only when the search term, filter,
 * category or sorting are updated.
 */
const useEmptyStateEvent = (
  resultAmount: number,
  isLoading: boolean,
  analyticsContext: string,
  queryDependencies: any[],
) => {
  const [hasQueryChanged, setQueryChanged] = useState(false)
  const noResults = resultAmount === 0

  // Check if query params or category changed
  useEffect(() => {
    setQueryChanged(true)
  }, [...queryDependencies])

  // Fire only if query changed and loading has finished
  useEffect(() => {
    if (hasQueryChanged && !isLoading && noResults) {
      emptyStateEvent(analyticsContext)
      setQueryChanged(false)
    }
  }, [noResults, isLoading])
}

export default useEmptyStateEvent
